import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";

export default class InitDashboardDataTask extends Task {
    constructor(assetLibrary, dashboardData) {
        super();

        this.execute = (callback, progressCallback) => {
            const dashboardDataJson = assetLibrary.getAsset("dashboard-data");
            dashboardData.setPropertiesFromObject(dashboardDataJson);
            callback(this);
        }
    }
}